import { render } from "./AddModalTypeActeur.vue?vue&type=template&id=a182e24a&ts=true"
import script from "./AddModalTypeActeur.vue?vue&type=script&lang=ts"
export * from "./AddModalTypeActeur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__